<template>
  <div class="Bracket content">
      <div class="banner">
        <Banner v-if="tournament" v-bind:text="tournament.name"></Banner>
        <Banner v-else v-bind:text="'4 OH 4'"></Banner>
      </div>

      <div style="grid-area: main;">

        <div v-if="!(tournament==undefined)">

            <div class="nice-text shadow" v-if="(tournament.teams.length < 4)">
                You haven't added enough teams to your tournament yet. Add at least four teams to create a bracket!
            </div>

            <div class="nice-text shadow" v-if="(tournament.teams.length >= 4) && (tournament.bracket.length < 2) && (tournament.teams.length <= 8)">
                There is no bracket for this tournament yet.
            </div>

            <div class="nice-text shadow" v-if="tournament.teams.length > 8">
                Brackets for more than 8 teams are currently not supported.
            </div>

            <div class="btns">
                <button class="buttonBigStyle" v-on:click="openTournament">EDIT TOURNAMENT</button>
                <button v-if="(tournament.teams.length >= 4) && (tournament.bracket.length < 2) && (tournament.teams.length <= 8)" v-on:click="generateBracket" class="buttonBigStyle">GENERATE BRACKET</button>
                <button v-if="(tournament.bracket.length >= 2) && (tournament.teams.length >= 4)" v-on:click="generateBracket" class="buttonBigStyle">REGENERATE BRACKET</button>
            </div>


            <div v-if="(tournament.bracket.length >= 2) && (tournament.teams.length >= 4)" v-bind:class="bracketSizeClass">
                <BracketEntry v-if="tournamentSize >= 3" class="q3" v-bind:game="tournament.bracket[2][2]" v-bind:tournament="tournament" v-bind:stageIndex="2" v-bind:gameIndex="2"></BracketEntry>
                <BracketEntry v-if="tournamentSize >= 3" class="q4" v-bind:game="tournament.bracket[2][3]" v-bind:tournament="tournament" v-bind:stageIndex="2" v-bind:gameIndex="3"></BracketEntry>
                <BracketEntry v-if="tournamentSize >= 3" class="q2" v-bind:game="tournament.bracket[2][1]" v-bind:tournament="tournament" v-bind:stageIndex="2" v-bind:gameIndex="1"></BracketEntry>
                <BracketEntry v-if="tournamentSize >= 3" class="q1" v-bind:game="tournament.bracket[2][0]" v-bind:tournament="tournament" v-bind:stageIndex="2" v-bind:gameIndex="0"></BracketEntry>
                <BracketEntry class="s2" v-bind:game="tournament.bracket[1][1]" v-bind:tournament="tournament" v-bind:stageIndex="1" v-bind:gameIndex="1"></BracketEntry>
                <BracketEntry class="s1" v-bind:game="tournament.bracket[1][0]" v-bind:tournament="tournament" v-bind:stageIndex="1" v-bind:gameIndex="0"></BracketEntry>
                <BracketEntry class="f" v-bind:game="tournament.bracket[0][0]" v-bind:tournament="tournament" v-bind:stageIndex="0" v-bind:gameIndex="0"></BracketEntry>
            </div>

        </div>
        <div class="nice-text shadow" v-else>
            OOPS! We couldn't find this tournament.
         </div>




    </div>
  </div>
</template>

<script>
import BracketEntry from '@/components/BracketEntry.vue'
import Banner from '@/components/Banner.vue'
export default {
  name: 'Bracket',
  components: {
      BracketEntry,
      Banner
  },

  data: function(){
      return{
      }
  },

  computed: {
      tournament(){
          return this.$store.getters.tournament(this.$route.params.tournamentId);
    },
    tournamentSize(){
        return this.tournament.bracket.length;
    },
    bracketSizeClass(){
        return "bracketWrapperSize" + this.tournamentSize;
    }

  },

  methods: {
    generateBracket(){
      this.$store.dispatch('generateBracket', this.tournament.id)
    },
    openTournament(){
        this.$router.push('/tournament/' + this.tournament.id);
    }
  }
}
</script>


<style scoped>
/* Bracket stuff */
.Bracket{
    display: grid;
    grid-template-areas:
        'banner banner banner'
        'left main right';
    color: orange;
}

.banner{
    grid-area: banner;
}

.nice-text {
    padding: 30px;
    margin-top: 20px;
    background-color: rgba(29, 29, 29, 0);
    text-align: center;
}

.btns{
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 15px;
}

.bracketWrapperSize3{
    grid-area: main;
    display: grid;
    grid-template-areas:
        'q1 s1 f'
        'q2 s1 f'
        'q3 s2 f'
        'q4 s2 f';
    grid-template-columns: minmax(350px, auto) minmax(350px, auto) minmax(350px, auto);
    grid-column-gap: 40px;
    grid-row-gap: 20px;
    /*margin: 20px;*/
    justify-items: center;
    align-items: center;
}
.bracketWrapperSize2{
    grid-area: main;
    display: grid;
    grid-template-columns: minmax(350px, auto) minmax(350px, auto);
    grid-template-areas:
        's1 f'
        's2 f';
    grid-column-gap: 40px;
    grid-row-gap: 20px;
    /*margin: 20px;*/
    justify-items: center;
    align-items: center;

}

.s1 { grid-area: s1;}
.s2 { grid-area: s2;}
.s3 { grid-area: s3;}
.s4 { grid-area: s4;}
.q1 { grid-area: q1;}
.q2 { grid-area: q2;}
.f  { grid-area: f;}

@media (max-width: 600px) {
  .bracketWrapperSize3{
    display: block;
  }
  .bracketWrapperSize2{
    display: block;
  }

}

</style>



// WEBPACK FOOTER //
// src/components/Bracket.vue